import { createRouter, createWebHistory } from 'vue-router';
import Main from '../components/Main.vue';
import Help from '../components/Help.vue';
import Player from '../components/Player.vue';
import PFLookup from '../components/PFLookup.vue';
import { getPlayerId } from './query';
import store from './store';

function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    meta: {
      title: capitalize(store.state.queryDifficulty)
    }
  },
  {
    path: '/help',
    name: 'Help',
    component: Help,
    meta: {
      title: 'Help'
    }
  },
  {
    path: '/player/:id',
    name: 'Player',
    component: Player,
    meta: {
      title: 'Player'
    },
    props: true
  },
  {
    path: '/pflookup/:pfid',
    name: 'PFLookup',
    component: PFLookup,
    meta: {
      title: 'Lookup'
    },
    beforeEnter: async (to, from, next) => {
      if (to.params.pfid && to.params.pfid.length >= 8) {
        await getPlayerId(to.params.pfid)
          .then((response) => {
            next({ name: 'Player', params: { id: response }});
          })
          .catch((error) => {
            console.log(error);
            next(Main);
          })
      } else {
        next(Main);
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Main',
    component: Main,
    meta: {
      title: capitalize(store.state.queryDifficulty)
    }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `DDGR Leaderboard: ${to.meta.title}`;
  next();
});

export default router;
